import { IProductDelivery, IproductReferenceDataInCountry } from 'types/orders';

/**
 * Indica si la línea del envío tiene reserva de stock activa (producto o referencia por `saleId`).
 */
export const productHasActiveStockReservation = (
  product: IProductDelivery,
  referenceList: IproductReferenceDataInCountry[]
): boolean => {
  if (product.stockReservation != null) return true;
  return referenceList.some(ref =>
    (ref.items ?? []).some(
      item => item.saleId === product.saleId && item.stockReservation != null
    )
  );
};
